'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@enlighten/design-system/dist/Box';
import Button from '@enlighten/design-system/dist/Button';
import Grid from '@enlighten/design-system/dist/Grid';
import Typography from '@enlighten/design-system/dist/Typography';
import { ChevronRight } from '@mui/icons-material';
import BackgroundMobile from '../../assets/images/fs-roof/img-7-mobile-background.png';
import BackgroundPc from '../../assets/images/fs-roof/img-7-pc-background.png';
const IS_NEXT_JS = process.env.NEXT_PUBLIC_IS_NEXT_JS === 'true' ||
    process.env.NEXT_PRIVATE_IS_NEXT_JS === 'true';
export default function FsRoofSection7({ onClick }) {
    return (_jsx(Grid, { width: "100%", sx: {
            justifyContent: {
                xs: 'center',
                md: 'flex-start',
            },
            alignItems: 'center',
            padding: { xs: '50px 24px', md: '180px 24px' },
            backgroundImage: {
                xs: `url(${IS_NEXT_JS ? BackgroundMobile.src : BackgroundMobile})`,
                md: `url(${IS_NEXT_JS ? BackgroundPc.src : BackgroundPc})`,
            },
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
        }, container: true, children: _jsxs(Box, { sx: {
                display: 'flex',
                flexDirection: 'column',
                maxWidth: '1440px',
                width: '100%',
                margin: '0 auto',
                textAlign: {
                    xs: 'center',
                    md: 'left',
                },
            }, children: [_jsx(Typography, { sx: {
                        fontSize: {
                            xs: '24px',
                            md: '40px',
                        },
                        fontWeight: 700,
                        lineHeight: {
                            xs: '34px',
                            md: '52px',
                        },
                        color: 'common.white',
                    }, children: `0원 지붕 태양광\n지금 무료로 확인하세요.` }), _jsx(Typography, { sx: {
                        marginTop: {
                            xs: '10px',
                            md: '16px',
                        },
                        fontSize: {
                            xs: '16px',
                            md: '22px',
                        },
                        fontWeight: 500,
                        lineHeight: {
                            xs: '24px',
                            md: '52px',
                        },
                        color: 'common.white',
                    }, children: "\uD22C\uC790\uBE44 0\uC6D0 / \uB2F4\uBCF4 \uD544\uC694\uC5C6\uC74C / \uC218\uC775 2.7\uC5B5" }), _jsx(Box, { sx: {
                        maxWidth: '252px',
                        width: '100%',
                        margin: {
                            xs: '24px auto 0',
                            md: '16px 0 0',
                        },
                    }, children: _jsx(Button, { sx: {
                            bgcolor: '#2452EE',
                            color: 'common.white',
                        }, endIcon: _jsx(ChevronRight, {}), fullWidth: true, onClick: onClick, children: "\uBB38\uC758\uD558\uAE30" }) })] }) }));
}
